import { InjectableClass } from '@fino/lib-injection';

export class ErrorBarController extends InjectableClass {
  constructor(errorService) {
    'ngInject';
    super({errorService});
  }

  $onInit() {
    this.errorFunction = this.onError.bind(this);
    this.errorService.onError(this.errorFunction);
  }

  $onDestroy() {
    this.errorService.offError(this.errorFunction);
  }

  onError(errors) {
    if (errors && errors.length) {
      this.show = true;
      return this.errors = errors;
    }
    this.show = false;
  }

  hide() {
    this.errorService.clear();
  }
}
